/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { CryptoRsa } from '@wit/vtv-x-foundation-lib';
import JSEncrypt from 'jsencrypt';

class CryptoRsaWeb implements CryptoRsa {
  private static instance: CryptoRsaWeb;

  // singleton
  constructor() {
    if (CryptoRsaWeb.instance) {
      return CryptoRsaWeb.instance;
    }
    CryptoRsaWeb.instance = this;
  }

  encrypt = (str: string, publicKey: string): Promise<string> => {
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(publicKey);
    const encrypted = encrypt.encrypt(str);

    // If the encryption failed throw an internal error
    if (encrypted === false) {
      throw new Error('Crypto: encryption failed');
    }

    return Promise.resolve(encrypted);
  };
}

const cryptoRsa = new CryptoRsaWeb();

export default cryptoRsa;
